import angular from 'angular';
import $ from 'jquery';
import moment from 'moment-timezone';

import {
	BeddyApiService,
	BeddyFolio
} from 'src/app/features/digital-payments';

import {
	ConfigurationManagerService
} from 'src/app/core';

import {
	MathUtils
} from 'src/app/shared/utils';

type BeddyPaymentsDialogInput = {
	amount: number,
	paymentMethodId: number
};

class BeddyPaymentsController {
	private folios: BeddyFolio[] = [];

	protected amountToPay: number;
	protected paymentMethodId: number;
	protected fetchingFolios = false;
	protected isOffline = false;
	protected message = '';
	protected needsSetup = false;
	protected operationInProgress = false;
	protected propertyId = '';
	protected selectedFolio?: BeddyFolio;
	protected searchText = '';
	protected showAmount = true;
	protected showBalance = true;
	protected visibleFolios: BeddyFolio[] = [];

	constructor(
		private $scope: any,
		options: BeddyPaymentsDialogInput,
		$timeout: any,
		private $translate: any,
		private $filter: any,
		private beddyApi: BeddyApiService,
		private configurationManagerService: ConfigurationManagerService,
		private $mdDialog: any
	) {
		this.amountToPay = MathUtils.round(options.amount);
		this.paymentMethodId = options.paymentMethodId;
		this.showAmount = !(this.configurationManagerService.getPreference('pms_payments.hide_total_amount'));
		this.showBalance = !(this.configurationManagerService.getPreference('pms_payments.hide_balance'));

		this.$scope.$on("connection:changed", (_: any, data: any) => {
			this.isOffline = data.status === 'offline';
		});

		$timeout(() => {
			this.fetchFolios();
		});
	}

	async pairShop(): Promise<void> {
		if (!this.propertyId) {
			return;
		}

		this.operationInProgress = true;
		this.message = this.$translate.instant('CASHREGISTER.BEDDY_PAYMENTS.ENABLING');

		try {
			await this.beddyApi.setupShop(this.paymentMethodId, this.propertyId);

			this.message = this.$translate.instant('CASHREGISTER.BEDDY_PAYMENTS.ENABLE_SUCCESSFUL');
			this.needsSetup = false;
			window.setTimeout(() => this.deleteMessage(), 1500);

			this.fetchFolios();
		} catch (error: any) {
			$('#BeddyPropertyIdField').trigger('focus');
			switch (error?.status) {
				case -1:
					this.message = '';
					break;
				case 404: case 403:
					this.message = this.$translate.instant('CASHREGISTER.BEDDY_PAYMENTS.INVALID_PROPERTY_ID');
					break;
				default:
					this.message = this.$translate.instant('CASHREGISTER.BEDDY_PAYMENTS.ENABLE_FAILED');
					break;
			}
		} finally {
			this.operationInProgress = false;
		}
	}

	deleteMessage(): void {
		this.message = '';
	}

	isMiscSale(folio: BeddyFolio): boolean {
		return folio.stayId == null;
	}

	parseBeddyDate(date: string): string {
		return moment(date, 'YYYY-MM-DD').format('L');
	}

	performSearch(): void {
		this.visibleFolios = this.folios;

		for (const word of this.searchText.split(/\W+/g)) {
			this.visibleFolios = this.$filter('filter')(this.visibleFolios, word);
		}

		if (!this.visibleFolios.find((folio: BeddyFolio) => folio === this.selectedFolio)) {
			this.selectedFolio = undefined;
		}
	}

	private async fetchFolios(): Promise<void> {
		if (this.$scope.$$destroyed) {
			return;
		}

		this.fetchingFolios = true;

		try {
			this.folios = await this.beddyApi.getRoomFolios(this.paymentMethodId).then((res) => res.folios.sort((a, b) => a.keyDoorCode! > b.keyDoorCode! ? 1 : -1));

			if (!this.configurationManagerService.getPreference('beddy.disable_rooms_filter')) {
				this.folios = this.folios.filter((folio) => {
					if (folio.checkInStatus === undefined) {
						return true;
					}

					return (folio.checkInStatus === 1 && folio.checkOutStatus === 0);
				});
			}

			this.visibleFolios = this.folios;
		} catch (error: any) {
			if (error?.status) {
				switch (error.status) {
					case -1:
						window.setTimeout(() => this.fetchFolios(), 1000);
						break;
					case 403:
						this.needsSetup = true;
						break;
					default:
						if (error.data?.error?.message?.error_code === 'CONNECTION_ERROR') {
							this.$mdDialog.cancel('BEDDY_OFFLINE');
						} else {
							this.$mdDialog.cancel('UNKNOWN_ERROR');
						}
						break;
				}
			} else {
				this.$mdDialog.cancel('UNKNOWN_ERROR');
			}
		} finally {
			this.fetchingFolios = false;
		}
	}

	cancel(): void {
		this.$mdDialog.cancel('CANCELED');
	}

	selectFolio(folio: BeddyFolio): void {
		this.selectedFolio = folio;
	}

	confirm(): void {
		if (this.selectedFolio) {
			this.$mdDialog.hide(this.selectedFolio);
		}
	}
}

BeddyPaymentsController.$inject = [
	"$scope",
	"options",
	"$timeout",
	"$translate",
	"$filter",
	"beddyApi",
	"checkManager",
	"$mdDialog"
];

export class BeddyPaymentsService {
	constructor(
		private $mdDialog: any
	) {
	}

	public show(options: BeddyPaymentsDialogInput): Promise<BeddyFolio> {
		return this.$mdDialog.show({
			controller: BeddyPaymentsController,
			controllerAs: '$ctrl',
			template: require('./beddy-payments.html'),
			locals: {
				options: options
			}
		});
	}
}

BeddyPaymentsService.$inject = [
	"$mdDialog"
];

angular.module('cashregister').service('beddyPayments', BeddyPaymentsService);